@if (isSpinnerVisible) {
  <div id="http-loader" [ngClass]="{'spinner-overlay': spinner === Spinkit.skThreeBounce}">
    
      @if (spinner === Spinkit.skLine) {
        <div class="loader-bg">
          <div class="sk-line-material" [class.colored]="!backgroundColor">
            <div class="sk-child sk-bounce1" [style.background-color]="backgroundColor"></div>
          </div>
        </div>
      }
      @if (spinner === Spinkit.skThreeBounce) {
        <div class="loader-bg-bounce">
          <div class="sk-three-bounce">
            <div class="sk-bounce1" [style.background-color]="backgroundColor"></div>
            <div class="sk-bounce2" [style.background-color]="backgroundColor"></div>
            <div class="sk-bounce3" [style.background-color]="backgroundColor"></div>
          </div>
        </div>
      }
  </div>
}
